import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { LoginService } from '@boxx/login-core';
import { Observable } from 'rxjs';
import { BoxxUtilsService } from 'src/services/BoxxUtils.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  constructor(
    private router: Router,
    private authSerevice: LoginService,
    private boxxUtils: BoxxUtilsService
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | boolean
    | UrlTree
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree> {
    return this.authSerevice.getSession().then(
      (user) => {
        if (!!user) {
          return true;
        }
        this.boxxUtils.showToastError({
          message: 'You have no privileges to access the resource',
          position: 'middle',
        });
        this.router.navigate(['/login']);
        return false;
      },
      (error) => {
        throw error;
      }
    );
  }
}
